'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
export default class FinderWrapper extends PureComponent {
  render() {
    const _this$props = this.props,
          {
      className
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["className"]);

    const wrapperClasses = classNames('finder-container', className);
    return /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
      className: wrapperClasses
    }));
  }

}
FinderWrapper.propTypes = {
  className: PropTypes.string
};